import { useNavigate, useLocation } from "react-router-dom";
import { ArrowDown, Heart, Linkedin, Mail } from "lucide-react";

const nav = [
    { label: "Home", href: "#home" },
    { label: "My Work", href: "#work" },
    { label: "About Me", href: "#about" },
];

export default function Footer() {
    const navigate = useNavigate();
    const location = useLocation();

    const go = (e, href) => {
        e.preventDefault();
        const scroll = () => {
            if (window.__lenis) window.__lenis.scrollTo(href, { offset: -90 });
            else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
        };
        if (location.pathname !== "/" && !document.querySelector(href)) {
            navigate("/");
            setTimeout(scroll, 450);
        } else {
            scroll();
        }
    };

    return (
        <footer className="border-t border-viol-light/40 bg-white py-12" data-testid="footer">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <div className="flex flex-col items-center justify-between gap-8 lg:flex-row">
                    <div className="flex items-center gap-3">
                        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-viol text-sm font-extrabold text-white">
                            SJ
                        </span>
                        <div>
                            <p className="text-sm font-extrabold text-ink">Sushma Jaykar</p>
                            <p className="text-xs text-mist">UI/UX Designer</p>
                        </div>
                    </div>

                    <nav className="flex flex-wrap items-center justify-center gap-1">
                        {nav.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={(e) => go(e, l.href)}
                                className="rounded-full px-4 py-2 text-sm font-medium text-mist transition-colors hover:bg-lav-100 hover:text-ink"
                                data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="/resume/Sushma_Jaykar_CV_2026.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-1 rounded-full px-4 py-2 text-sm font-medium text-mist transition-colors hover:bg-lav-100 hover:text-ink"
                            data-testid="footer-nav-resume"
                        >
                            Resume <ArrowDown className="h-3.5 w-3.5" />
                        </a>
                    </nav>

                    <div className="flex items-center gap-3">
                        <a
                            href="#"
                            onClick={(e) => e.preventDefault()}
                            className="flex h-10 w-10 items-center justify-center rounded-full bg-lav-100 text-xs font-extrabold text-viol ring-1 ring-lav-200 transition-all hover:bg-viol hover:text-white"
                            data-testid="footer-behance-link"
                            aria-label="Behance"
                            title="Behance — link to be added"
                        >
                            Bē
                        </a>
                        <a
                            href="https://www.linkedin.com/in/sushma-jaykar/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex h-10 w-10 items-center justify-center rounded-full bg-lav-100 text-viol ring-1 ring-lav-200 transition-all hover:bg-viol hover:text-white"
                            data-testid="footer-linkedin-link"
                            aria-label="LinkedIn"
                        >
                            <Linkedin className="h-4 w-4" />
                        </a>
                        <a
                            href="mailto:sushma.jaykar08@gmail.com"
                            className="flex h-10 w-10 items-center justify-center rounded-full bg-lav-100 text-viol ring-1 ring-lav-200 transition-all hover:bg-viol hover:text-white"
                            data-testid="footer-email-link"
                            aria-label="Email"
                        >
                            <Mail className="h-4 w-4" />
                        </a>
                    </div>
                </div>

                <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-lav-200 pt-6 sm:flex-row">
                    <p className="text-xs text-mist">© 2026 Sushma Jaykar</p>
                    <p className="hand flex items-center gap-1.5 text-xl text-viol">
                        Designed with curiosity ✦ and <Heart className="h-3.5 w-3.5 fill-sun text-sun-deep" />
                    </p>
                </div>
            </div>
        </footer>
    );
}
